import React, { Component } from 'react';
import './ExportResupplyReportPopup.css';
import Popup from '../../components/popup/Popup';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import Input from '../../inputs/input/Input';
import toasts from '../../utils/toasts';
import PrimaryButton from "../../components/primaryButton/PrimaryButton";
import SecondaryButton from "../../components/secondaryButton/SecondaryButton";

export default class ExportResupplyReportPopup extends Component {
	constructor(props) {
		super(props);
		this.state = {
			percentOverPar: '15'
		};
		this.inputRef = React.createRef();
	}

	componentDidMount = () => {
		if (this.inputRef.current) {
			this.inputRef.current.focus();
		}
	};

	_handleExport = () => {
		const percentOverPar = parseFloat(this.state.percentOverPar);
		if (isNaN(percentOverPar) || percentOverPar < 0) {
			toasts.show('Please enter a valid number (0 or greater)');
			return;
		}
		if (this.props.onExport) {
			this.props.onExport(percentOverPar);
		}
		this.props.onClose();
	};

	_handleChange = (value) => {
		this.setState({ percentOverPar: value });
	};

	render() {
		return (
			<Popup {...this.props} className="g-export-resupply-report-popup">
				<Card>
					<Label large black>
						Export Resupply Report
					</Label>
					<Label>Percent Over Par (e.g., 15 for 15%)</Label>
					<Input
						ref={this.inputRef}
						value={this.state.percentOverPar}
						onChange={this._handleChange}
						type="number"
						min="0"
						placeholder="15"
					/>
					<Label>Expired drugs will be ignored in this report</Label>

					<div className="actions">
						<SecondaryButton  onClick={this.props.onClose}>
							Cancel
						</SecondaryButton>
						<PrimaryButton  onClick={this._handleExport}>
							Export
						</PrimaryButton>
					</div>
				</Card>
			</Popup>
		);
	}
}




// WEBPACK FOOTER //
// ./src/popups/exportResupplyReportPopup/ExportResupplyReportPopup.jsx